export const ELLIPSIS_IN_BEGIN = 'ELLIPSIS_IN_BEGIN';
export const ELLIPSIS_IN_END = 'ELLIPSIS_IN_END';
export const ELLIPSIS_IN_MIDDLE = 'ELLIPSIS_IN_MIDDLE';
export const ELLIPSIS = '...';
